// Design System
import Link from 'jl-design-system/elements/link/Link';

// Config
import urlConstants from '@constants/urlConstants';

// Components
import BodyText from '@components/body-text';
import Container from '@components/container';

export const TermsConditions = () => (
  <Container marginTop="1">
    <BodyText testId="payment-agree-terms-conditions-privacy-notice">
      By placing your order you agree to the John Lewis{' '}
      <Link external target="_blank" to={urlConstants.JL_TERMS_CONDITIONS}>
        terms and conditions
      </Link>
      . John Lewis will process your personal data as set out in our{' '}
      <Link external target="_blank" to={urlConstants.JL_PRIVACY_NOTICE}>
        privacy notice
      </Link>
      .
    </BodyText>
  </Container>
);

export default TermsConditions;
